import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
// components
import ExcipientTypeTable from './ExcipientTypeTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_EXCIPIENT_TYPES_ROUTE, ADD_NEW_TEXT, EXCIPIENT_TYPES_TEXT } from 'constants/index';

const ExcipientType: FC = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{EXCIPIENT_TYPES_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_EXCIPIENT_TYPES_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <ExcipientTypeTable />
    </Fragment>
  );
};

export default ExcipientType;
